import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormLabel,
  Input,
  Radio,
  RadioGroup,
  Select,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { selectStyles } from "../../utils/selectStyel";
export default function Toolbox({
  schema,
  onAddSection,
  onAddField,
  onRemoveSection,
  onRemoveField,
  onUpdateField,
}) {
  const [sectionKey, setSectionKey] = useState("");
  const [sectionLabel, setSectionLabel] = useState("");

  const [targetSection, setTargetSection] = useState(
    Object.keys(schema)[0] || "",
  );
  const [fieldKey, setFieldKey] = useState("");
  const [fieldMessage, setFieldMessage] = useState("");
  const [fieldType, setFieldType] = useState("String");
  const [isRepeatable, setIsRepeatable] = useState(false);
  const [multiselectType, setMultiselectType] = useState("Checkbox");

  // --- Add Section ---
  const handleAddSection = () => {
    if (!sectionKey || !sectionLabel) return;

    onAddSection(sectionKey, {
      MESSAGE: sectionLabel,
      FIELDS: {},
    });

    setTargetSection(sectionKey);
    setSectionKey("");
    setSectionLabel("");
  };

  useEffect(() => {
    if (!targetSection || !schema[targetSection]) {
      const keys = Object.keys(schema);
      if (keys.length > 0) {
        setTargetSection(keys[keys.length - 1]);
      }
    }
  }, [schema, targetSection]);

  // --- Add Field ---
  const handleAddField = () => {
    if (!targetSection || !schema[targetSection]) return;
    if (!fieldKey || !fieldMessage) return;

    let fieldValue;

    if (isRepeatable) {
      fieldValue = [
        {
          PREVIEW: {
            TYPE: "Preview",
            MESSAGE: "Preview",
            PREVIEW_VALUE: [],
          },
          [fieldKey]: {
            TYPE: fieldType,
            MESSAGE: fieldMessage,
            ...(fieldType === "Multiselect" && {
              MULTISELECT_TYPE: multiselectType,
            }),
          },
        },
      ];
    } else {
      fieldValue = {
        TYPE: fieldType,
        MESSAGE: fieldMessage,
        ...(fieldType === "Multiselect" && {
          MULTISELECT_TYPE: multiselectType,
        }),
      };
    }

    onAddField(targetSection, fieldKey, fieldValue, isRepeatable);

    setFieldKey("");
    setFieldMessage("");
    setFieldType("String");
    setMultiselectType("Checkbox");
    setIsRepeatable(false);
  };

  // --- Remove Section ---
  const handleRemoveSection = () => {
    if (!targetSection) return;
    onRemoveSection(targetSection);
    setTargetSection(Object.keys(schema)[0] || "");
  };
  const options = Object.keys(schema).map((k) => ({
    value: k,
    label: `${k} — ${schema[k]?.MESSAGE || ""}`,
  }));

  return (
    <Box border="1px solid #e2e8f0" p={4} borderRadius="md" mb={4}>
      <VStack align="stretch" spacing={3}>
        {/* Add Section */}
        <Text fontWeight="bold">Add Section</Text>
        <Input
          value={sectionKey}
          onChange={(e) => setSectionKey(e.target.value)}
          placeholder="Section Key e.g. NEW_SECTION"
          borderRadius="md"
          borderColor="gray.600"
          bg="white"
        />
        <Input
          value={sectionLabel}
          onChange={(e) => setSectionLabel(e.target.value)}
          placeholder="Section Label (MESSAGE)"
          borderRadius="md"
          borderColor="gray.600"
          bg="white"
        />
        <Button onClick={handleAddSection} colorScheme="blue">
          Add Section
        </Button>
        <Divider borderColor="teal" />
        {/* Add / Update / Remove Field */}
        <Text fontWeight="bold" mt={2}>
          Field Editor
        </Text>
        <Box mb={2}>
          <ReactSelect
            value={options.find((opt) => opt.value === targetSection) || null}
            onChange={(selected) => setTargetSection(selected?.value || "")}
            options={options}
            isClearable
            placeholder="Select section..."
            styles={selectStyles}
            menuPortalTarget={document.body}
          />
          <span style={{ textAlign: "center", color: "gray" }}>
            Please select section to add field
          </span>
        </Box>

        <Input
          value={fieldKey}
          onChange={(e) => setFieldKey(e.target.value.toUpperCase())}
          placeholder="Field Key e.g. NEW_FIELD"
          borderRadius="md"
          borderColor="gray.600"
          bg="white"
        />
        <Input
          value={fieldMessage}
          onChange={(e) => setFieldMessage(e.target.value)}
          placeholder="Field MESSAGE (label)"
        />
        <Select
          value={fieldType}
          onChange={(e) => setFieldType(e.target.value)}
          borderRadius="md"
          borderColor="gray.600"
          bg="white"
        >
          <option value="String">String</option>
          <option value="Date">Date</option>
          <option value="Numeric">Numeric</option>
          <option value="Dropdown">Dropdown</option>
          <option value="Multiselect">Multi Select</option>
          <option value="TextBox">TextBox</option>
        </Select>
        <Checkbox
          isChecked={isRepeatable}
          onChange={(e) => setIsRepeatable(e.target.checked)}
        >
          Repeatable (array)
        </Checkbox>
        {fieldType === "Multiselect" && (
          <FormControl my={2}>
            <FormLabel>Multiselect Type</FormLabel>

            <RadioGroup
              value={multiselectType}
              onChange={setMultiselectType}
              size="lg"
            >
              <VStack spacing={2} alignItems="start">
                <Radio value="Select_All_With_CheckBox">
                  Select All w/ Checkbox
                </Radio>
                <Radio value="Checkbox">Checkbox</Radio>
                <Radio value="Radio">Radio</Radio>
              </VStack>
            </RadioGroup>
          </FormControl>
        )}

        <Button onClick={handleAddField} colorScheme="green">
          Add Field
        </Button>
        <Button onClick={handleRemoveSection} colorScheme="red">
          Remove Section
        </Button>
      </VStack>
    </Box>
  );
}
